import type { ComponentChildren } from "preact";
import { cx } from "../cx";

export type BadgeTone = "neutral" | "red" | "teal" | "gold" | "ink" | "ok";

export function Badge({ tone = "neutral", children, class: cls }: { tone?: BadgeTone; children: ComponentChildren; class?: string }) {
  return <span class={cx("badge", `badge--${tone}`, cls)}>{children}</span>;
}

export function LockIcon({ size = 14, class: cls }: { size?: number; class?: string }) {
  return (
    <svg
      class={cx("lock-icon", cls)}
      viewBox="0 0 16 16"
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
    >
      <path d="M4 7V5a4 4 0 0 1 8 0v2" fill="none" stroke="currentColor" stroke-width="1.8" />
      <rect x="2.5" y="7" width="11" height="8" fill="currentColor" />
    </svg>
  );
}

/** "LVL 5" with a padlock; `weapon` marks weapon levels (attachments, camos) instead of player levels. */
export function LockBadge({ level, weapon = false, class: cls }: { level: number; weapon?: boolean; class?: string }) {
  return (
    <span class={cx("lockbadge", cls)} title={weapon ? `Reach weapon level ${level}` : `Reach player level ${level}`}>
      <LockIcon size={11} />
      <span>{weapon ? `WPN ${level}` : `LVL ${level}`}</span>
    </span>
  );
}
